import { FieldErrors } from "react-hook-form";
import { ErrorMessage as HookFormErrorMessage } from "@hookform/error-message";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

interface ErrorMessageProps {
  errors: FieldErrors<any>;
  name: string;
}
export const ErrorMessage = ({ errors, name }: ErrorMessageProps) => {
  return (
    <HookFormErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => (
        <div className="mt-2 flex items-center gap-2 text-danger-500 text-sm">
          <FontAwesomeIcon icon={faExclamationTriangle} className="w-4 h-4 flex-shrink-0" />
          {message}
        </div>
      )}
    />
  );
};
